import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-lg font-jakarta text-base ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    defaultVariants: {
      size: "primary",
      variant: "primary",
    },
    variants: {
      size: {
        icon: "h-10 w-10",
        lg: "h-11 rounded-full px-8",
        primary: "h-12 px-6 py-2",
        sm: "h-9 rounded-md px-3",
      },
      variant: {
        blank: `bg-transparent rounded-full w-10 h-10
          hover:border-2 hover:border-new-beginnings-base hover:shadow-primary-button
          focus:outline focus:outline-2 focus:outline-new-beginnings-base`,
        "chevron-right": `focus:text-support-tints-400  rounded-l-sm rounded-r-none justify-start`,
        dot: `outline-offset-4 rounded-full w-2 h-2 mr-4 bg-new-beginnings-base focus:outline focus:outline-2 focus:outline-new-beginnings-base`,
        friendly: `bg-friendly-base text-new-beginnings-base
          border-2 border-transparent
          hover:bg-new-beginnings-tints-800 hover:text-new-beginnings-base hover:shadow-primary-button
          hover:border hover:border-2 hover:border-new-beginnings-base
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-new-beginnings-base`,
        ghost: `text-new-beginnings-base 
          hover:bg-new-beginnings-tints-800 hover:shadow-primary-button
          focus:outline focus:outline-2 focus:outline-new-beginnings-base`,
        outline: `border-2 border-new-beginnings-base text-new-beginnings-base bg-background 
          hover:bg-new-beginnings-tints-800 hover:shadow-primary-button
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-new-beginnings-base`,
        "outline-secondary": `border-2 border-support-tints-400 text-new-beginnings-base bg-background 
          hover:bg-new-beginnings-tints-800 hover:shadow-primary-button hover:text-new-beginnings-base
          focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-support-tints-400`,
        plain: "",
        primary: `bg-new-beginnings-base text-white 
          border-2 border-transparent
          hover:bg-new-beginnings-tints-800 hover:text-new-beginnings-base hover:shadow-primary-button
          hover:border hover:border-2 hover:border-new-beginnings-base
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-new-beginnings-base`,
        secondary: `bg-white text-new-beginnings-base 
          hover:bg-new-beginnings-tints-800 hover:text-new-beginnings-base hover:shadow-primary-button
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-new-beginnings-base`,
      },
    },
  },
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
